import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flex, Feedback, Text } from '@hausgold/designsystem';
import { useField, ErrorMessage } from 'formik';
import { FIELD_TYPE_NUMERICAL } from '../../../utils/CONSTANTS.js';
import Default from './Default.js';
import { jsx } from '@emotion/react';
var Number = function Number(_ref) {
  var stepKey = _ref.stepKey,
    lineKey = _ref.lineKey,
    type = _ref.type,
    unit = _ref.unit,
    placeholder = _ref.placeholder,
    mandatory = _ref.mandatory,
    options = _ref.options;
  var _useField = useField(stepKey),
    _useField2 = _slicedToArray(_useField, 2),
    meta = _useField2[1];
  return jsx(Fragment, null, jsx(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, jsx("div", null, jsx(Default, _extends({
    type: "text",
    onKeyDown: function onKeyDown(event) {
      if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' &&
      // Allow hotkeys (CTRL+C, CTRL+V)
      !event.ctrlKey && !event.altKey &&
      // Allow mac's hotkeys (CMD+C, CMD+V)
      !event.metaKey &&
      // Allow left and right arrow keys
      event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        event.preventDefault();
      }
    },
    inputMode: "numeric",
    name: stepKey
    // only show unit on numerical input
    ,

    unit: type === FIELD_TYPE_NUMERICAL ? unit : null
  }, options, {
    stepKey: stepKey,
    lineKey: lineKey,
    placeholder: "".concat(placeholder || '', " ").concat(mandatory ? '*' : '')
  })), jsx(Flex, {
    mt: 2,
    justifyContent: "space-between"
  }, jsx(ErrorMessage, {
    name: stepKey
  }, function (message) {
    return jsx(Feedback, {
      mb: 0,
      mx: "auto",
      display: "block"
    }, message);
  }), mandatory && !(meta.touched && meta.error) && jsx(Text, {
    as: "span",
    ml: "auto",
    color: "gray.400",
    mb: 0
  }, "* Pflichtfeld")))));
};
Number.propTypes = {
  mandatory: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  unit: PropTypes.string,
  stepKey: PropTypes.string.isRequired,
  lineKey: PropTypes.string.isRequired,
  options: PropTypes.object
};
Number.defaultProps = {
  unit: null,
  placeholder: null,
  mandatory: false,
  options: {}
};
export { Number as default };